const care = {
  residentCare: {
    hero: {
      eyebrow: "A second home",
      title: "Resident Care",
      subtitle: "A loving home — not an institution.",
    },
    items: {
      comfortableStay: {
        title: "Comfortable Stay",
        desc: "Clean, well-ventilated rooms with attendants on every floor.",
      },
      nutritiousMeals: {
        title: "Nutritious Meals",
        desc: "Three meals + tea, prepared to suit elderly dietary needs.",
      },
      medicalCare: {
        title: "Medical Care",
        desc: "Daily medicines, on-call doctors, hospital tie-ups.",
      },
      companionship: {
        title: "Companionship",
        desc: "Group activities, satsang, festivals and birthday celebrations.",
      },
      emotionalSupport: {
        title: "Emotional Support",
        desc: "Counseling, family video calls and one-to-one care.",
      },
      ritualsDignity: {
        title: "Rituals & Dignity",
        desc: "Punya Tithi, last rites and remembrance — performed with respect.",
      },
    },
    form: {
      eyebrow: "Apply for Admission",
      heading: "Resident Admission Enquiry",
      description:
        "Please share complete details of the elder seeking admission. Our admission team will get in touch within 1–2 working days.",
      select: "Select…",
      submit: "Submit Admission Enquiry",
      submitting: "Submitting...",
      sections: {
        resident: "Resident Details",
        health: "Health & Mobility",
        admission: "Admission Details",
        applicant: "Applicant / Family Contact",
      },
      labels: {
        residentName: "Resident Full Name *",
        gender: "Gender",
        dob: "Date of Birth",
        bloodGroup: "Blood Group",
        maritalStatus: "Marital Status",
        religion: "Religion",
        jainStatus: "Jain Status",
        caste: "Caste / Community",
        education: "Education",
        occupation: "Past Occupation",
        residentMobile: "Resident Mobile",
        aadhaar: "Aadhaar Number",
        identificationMark: "Identification Mark",
        previousAddress: "Previous Address",
        city: "City",
        state: "State",
        pincode: "Pincode",
        healthConditions: "Existing Health Conditions",
        currentMedications: "Current Medications",
        mobility: "Mobility",
        admissionType: "Admission Type",
        monthlyMaintenance: "Monthly Maintenance Budget (₹)",
        preferredDate: "Preferred Admission Date",
        referredBy: "Referred By",
        reason: "Reason for Admission *",
        applicantName: "Applicant Name *",
        relation: "Relation to Resident",
        mobile: "Mobile *",
        altMobile: "Alt Mobile",
        email: "Email",
        applicantAddress: "Applicant Address",
        emergencyName: "Emergency Contact Name",
        emergencyMobile: "Emergency Mobile",
        emergencyRelation: "Emergency Relation",
        notes: "Additional Notes",
      },
      placeholders: {
        bloodGroup: "e.g. B+",
        healthConditions: "Diabetes, BP, joint pain, etc.",
        relation: "Son / Daughter / Nephew…",
      },
      options: {
        gender: {
          male: "Male",
          female: "Female",
          other: "Other",
        },
        marital: {
          single: "Single",
          married: "Married",
          widowed: "Widowed",
          divorced: "Divorced",
        },
        jain: {
          shwetambar: "Shwetambar",
          digambar: "Digambar",
          sthanakvasi: "Sthanakvasi",
          terapanthi: "Terapanthi",
          other: "Other",
        },
        mobility: {
          independent: "Independent",
          walkingStick: "Walking stick",
          walker: "Walker",
          wheelchair: "Wheelchair",
          bedRidden: "Bed-ridden",
        },
        admission: {
          free: "Free",
          paid: "Paid",
          subsidised: "Subsidised",
        },
      },
    },
    toast: {
      error: "Could not submit.",
      success:
        "Enquiry received. Our admission team will call within 1–2 working days.",
    },
  },

  healthcare: {
    hero: {
      eyebrow: "Healthcare",
      title: "Care that does not wait",
      subtitle:
        "From daily medicines to midnight emergencies, our medical program keeps our seniors safe and our community supported.",
    },
    metrics: {
      patientsServed: "Patients Served / Year",
      freeCamps: "Free Camps Each Year",
      medicineKits: "Medicine Kits Distributed",
      emergency: "Emergency Availability",
    },
    initiatives: {
      eyebrow: "Healthcare Initiatives",
      heading: "A clinic, a camp, an ambulance — all under one roof",
      items: {
        clinic: {
          title: "On-Campus Clinic",
          body: "A 4-cabin clinic with daily nursing rounds and visiting consultants across specialties.",
        },
        camps: {
          title: "Free Health Camps",
          body: "Monthly camps for dental, eye, diabetes and cardiac screening — open to nearby communities.",
        },
        medicine: {
          title: "Medicine Support",
          body: "Free monthly medicine kits for residents and underprivileged seniors registered with us.",
        },
        emergency: {
          title: "Emergency Response",
          body: "In-house ambulance and hospital tie-ups for round-the-clock emergencies.",
        },
      },
    },
    programs: {
      eyebrow: "Treatment Programs",
      heading: "Active care across departments",
      patients: "patients",
      items: {
        diabetes: "Diabetes Management",
        hypertension: "Hypertension Care",
        cardiac: "Cardiac Monitoring",
        physiotherapy: "Physiotherapy",
        wellness: "General Wellness",
        eye: "Eye Care",
      },
    },
    support: {
      imgAlt: "Doctor performing a routine check-up",
      eyebrow: "Medical Support Activities",
      heading: "Where every check-up matters",
      items: {
        monitoring:
          "Daily blood-pressure and sugar monitoring for at-risk residents.",
        dental: "Quarterly free dental camp — open to the local community.",
        vaccination:
          "Vaccination drives (flu, pneumonia, COVID boosters) twice a year.",
        lab: "Lab tie-up for at-cost diagnostics — fees waived for residents.",
        counselling: "Counselling and yoga sessions for senior mental wellness.",
      },
    },
    cta: {
      heading: "Sponsor a day of medical care",
      description:
        "Cover doctor visits, medicines and diagnostics for one elder, for one day.",
      support: "Support Healthcare",
      getInTouch: "Get in Touch",
    },
  },

  elderCare: {
    hero: {
      eyebrow: "Elder Care",
      title: "Lifetime care, with dignity",
      subtitle:
        "Shelter, food, medicine, companionship and rituals — provided with the warmth of family, never as charity.",
    },
    impact: {
      residentsCared: "Residents Cared For",
      lifetimeCare: "Of Lifetime Care",
      mealsServed: "Meals Served / Year",
      donorFunded: "Donor Funded",
    },
    overview: {
      eyebrow: "Program Overview",
      heading: "Care that goes beyond a room and a meal",
      description:
        "Every resident receives the same standard of care — whether they came to us with means or with nothing at all.",
    },
    services: {
      shelter: {
        title: "Lifetime Shelter",
        body: "A clean, safe room and a place at the family table — for as long as our elders need it, at no cost.",
      },
      bhojan: {
        title: "Daily Bhojan Seva",
        body: "Three nutritious, freshly cooked Jain-style meals every day, planned with dietary needs in mind.",
      },
      care: {
        title: "Round-the-Clock Care",
        body: "Trained caretakers, weekly doctor rounds and 24×7 nursing for residents who need assistance.",
      },
      dignity: {
        title: "Dignity & Rituals",
        body: "Birthdays, festivals and last rites are observed with the same care a family would offer.",
      },
    },
    facilities: {
      imgAlt: "Residents enjoying a shared meal",
      eyebrow: "Facilities & Services",
      heading: "A home built around our elders",
      description:
        "Designed with mobility, safety and community in mind — every corner serves a purpose.",
      items: {
        capacity: "120+ resident capacity across A, B and C blocks",
        clinic: "In-house clinic with daily nursing rounds",
        physio: "Physiotherapy & yoga room",
        library: "Library, prayer hall and satsang space",
        access: "Wheelchair-friendly access throughout",
        garden: "Garden, walking paths and outdoor seating",
      },
    },
    stories: {
      eyebrow: "Impact Stories",
      heading: "Voices from our parivaar",
      items: {
        kantilal: {
          name: "Kantilal Bhai",
          years: "12 years with us",
          quote: "I came alone. I have a family now — 119 brothers and sisters.",
        },
        saroj: {
          name: "Saroj Ben",
          years: "5 years with us",
          quote:
            "Every birthday since I came here has had a cake. I had forgotten what that felt like.",
        },
        hasmukh: {
          name: "Hasmukh Bhai",
          years: "9 years with us",
          quote:
            "When I fell ill, the doctor came at midnight. Where else would that happen?",
        },
      },
    },
    gallery: {
      eyebrow: "Photo Gallery",
      heading: "Moments from our home",
      viewFull: "View Full Gallery",
      items: {
        care: "Compassionate Care",
        meals: "Shared Meals",
        health: "Daily Health Checks",
      },
    },
    cta: {
      heading: "Sponsor an Elder's Care",
      description:
        "Your support funds shelter, meals and medicine for the seniors who call Jivandhara home.",
      support: "Support Elder Care",
      visit: "Visit the Home",
    },
  },
};

export default care;
